<div class="col-12 col-am-12 col-md-10 col-lg-10 mx-auto">
    <div class="row mt10">
        <!-- <div class="col-12 col-am-12 col-md-12 col-lg-12 mx-auto maintanBox fs-16 regular mb-4">
            <span class="fs-16 bold">System Maintenance Notice</span><br>
            <div class="clear10"></div>
            <span>MyTL will be offline <span class="bold">June 4, 2022,</span> from approximately <span class="bold">10:30 pm to 10:30 am ET</span>. During this time you will not be able to log into or access MyTL. If you would like to access our online sales portal, you can do so directly by clicking this link:<a href=" https://www.getreliable.com/getreliable/login.aspx" target="_blank"> https://www.getreliable.com/getreliable/login.aspx.</a></span>
            <br>
            <div class="clear10"></div>
            <span>Thank you,</span><br>
            <div class="clear10"></div>
            <span>Travelance Team</span>
        </div> -->
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 pl4">
            <div class="clear40"></div>
            <div class="col-12 col-sm-12 col-md-10 col-lg-9">
                <img class="moblogo" src="./assets/images/TL-Logo.svg">
                <div class="clear30"></div>
                <div class="mobcenter">
                    <label class="semi-bold fs-36 m-0 pl18 blue tabfs24 mobfs-22"><span class="txt-blue">MyTL</span> Portal </label>
                </div>
                <div class="clear20"></div>
                <!-- <p class="fs-20 blue regular pl18">Manage and create login accounts for your staff members in different departments. It’s simple and easy.</p> -->

                <p class="fs-20 blue regular pl18 tabfs16 mobfs-14 mobcenter">From one location, you can:</p>
                <ul class="fs-20 blue regular pl60 tabfs16 mobfs-14">
                    <li>Access your Travelance account </li>
                    <li>Complete online training</li>
                    <li>Sell and administer policies</li>
                </ul>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mobpad7">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="col-12 col-sm-12 col-md-10 col-lg-9 pad32 ml60 box">
                    <!-- <label class="fs-20 blue regular m-0">Enter the details below</label>
                    <div class="clear10"></div> -->
                    <div *ngIf="showTimer" class="alert alert-danger timerclass">{{display}}</div>
                    <div class="clear5"></div>
                    <div class="semi-bold black fs-16">Email</div>
                    <div class="clear"></div>
                    <!-- <input type="email" autofocus formControlName="email" class="instyle regular w-100 olnone form-control" onkeydown="if(event.key === ' '){ event.preventDefault(); }" oninput="event.target.value = event.target.value.toLowerCase().replace(/[^a-z0-9@._]/g, '')" placeholder="example@example.com"> -->
                    <input type="email" autofocus formControlName="email" class="instyle regular w-100 olnone form-control" placeholder="example@example.com"(change)="emailCheck()">
                    <div *ngIf="emailerror" class="invalid-feedback1">Email must be a valid email address</div>
                    <div class="clear10"></div>
                    <label class="semi-bold black fs-16">Password</label>
                    <div class="clear"></div>
                    <div class="password-input">
                        <input type="{{type}}" formControlName="password" class="instyle regular w-100 olnone form-control"  [ngClass]="{ 'is-invalid': submitted && f.password.errors }">

                        <div class="clear5"></div>
                        <img src="./assets/images/eye.png" class="cp password-img img-responsive cp" (click)="toggleShow()">

                    </div>
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>

                    </div>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-1 col-sm-1 col-md-1 col-lg-1">
                            <input type="checkbox" [checked]="rememberMeChecked1 == true" value="true" (change)="rememberMe($event)">
                        </div>
                        <div class="col-5 col-sm-5 col-md-5 col-lg-5">
                            <label for="vehicle1" class="fs-14 regular black">Remember me</label>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-right">
                            <label class="fs-14 regular link cp olnone" routerLink="/forgot-password">Forgot password</label>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <re-captcha  (resolved)="resolved($event)" siteKey="6LcRs3crAAAAAIaob4qTZQyYqAQoj24rAy43s2zw"></re-captcha>                            
                    </div>
                    <div class="clear20"></div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                        <!-- <button [disabled]="loading" type="submit" class="proceedbtn semi-bold olnone" routerLink="/set-own-password">Proceed</button> -->
                        <button [hidden]="showTimer==true" type="submit" class="proceedbtn semi-bold olnone">Proceed</button>
                    </div>
                    <div class="clear10"></div>
                    <div *ngIf="error && isOnline==true" class="alert alert-danger">{{error}}</div>
                    <div *ngIf="terminatedErrorMsgRed && isOnline==true" class="alert alert-danger">There is an error with your account. Please email <a href="mailto:join@travelance.ca">join@travelance.ca</a> for more info.</div>
                    <div *ngIf="isOnline==false" class="alert alert-danger">{{errorMessage}}</div>
                </div>
                <div class="col-12 col-sm-12 col-md-10 col-lg-9 padTerms ml60 text-center">
                    <div class="fs-12 regular">
                        <a href="https://www.travelance.ca/terms-conditions" target="_blank">Terms and Conditions</a> | <a href="https://www.travelance.ca/privacy-policy" target="_blank">Privacy Policy</a> | <a href="https://www.travelance.ca/terms-of-use" target="_blank">Terms Of Use</a> <br>
                        © {{currentYear}} Travelance Inc. All rights reserved. 
                    </div>
                </div>
            </form>
        </div>
      
    </div>
</div>




<!-- <p class="abc">login-page works!</p>
<p>
    <button type="button" class="btn  retrybtn fs-16 regular" (click)="goToHome()">
       CLICK</button>  
</p> -->